import { render, staticRenderFns } from "./AddSchema.vue?vue&type=template&id=075b152f&"
import script from "./AddSchema.vue?vue&type=script&lang=js&"
export * from "./AddSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports